import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

interface UploadProgressListProps {
  isUploading: boolean;
  uploadProgress?: { [projectName: string]: number };
}

const UploadProgressList: React.FC<UploadProgressListProps> = ({
  isUploading,
  uploadProgress = {},
}) => {
  if (!isUploading || Object.keys(uploadProgress).length === 0) {
    return null;
  }

  return (
    <Box mb={3}>
      <Typography variant="subtitle2" gutterBottom>
        Upload Progress
      </Typography>
      {Object.entries(uploadProgress).map(([projectName, progress]) => (
        <Box key={projectName} mb={1}>
          <Box display="flex" justifyContent="space-between" mb={0.5}>
            <Typography variant="body2">{projectName}</Typography>
            <Typography variant="body2">{Math.round(progress)}%</Typography>
          </Box>
          <LinearProgress variant="determinate" value={progress} />
        </Box>
      ))}
    </Box>
  );
};

export default UploadProgressList;
